import styled, { css } from 'styled-components';
import { isMobileStyleMixin, Tag } from '@amzn/storm-ui';

interface FlagProps {
  $isInverted?: boolean;
  $isMobile?: boolean;
}

export const Flag = styled(Tag)<FlagProps>`
  vertical-align: middle;
  margin-inline-start: ${({ theme }) => theme.spacing.xxsmall.default};
  ${isMobileStyleMixin(css`
    margin-inline-start: ${({ theme }) => theme.spacing.xxsmall.mobile};
  `)};

  ${({ $isInverted }) =>
    $isInverted &&
    css`
      background-color: ${({ theme }) => theme.color.gray[0]};
      color: ${({ theme }) => theme.color.gray[900]};
    `}

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      max-height: 19px;
      padding: 2px 5px;
      margin-inline: auto 0;
      border-radius: 3px;
      align-items: center;
    `}

  ${({ $isMobile, $isInverted }) =>
    $isMobile &&
    $isInverted &&
    css`
      margin-inline-start: ${({ theme }) => theme.spacing.xsmall.default};
    `}
`;

export const BetaAIFlag = styled(Flag)<FlagProps>`
  background-color: ${({ theme }) => theme.color.gray[900]};
  color: ${({ theme }) => theme.text.color.inverted};

  ${({ $isInverted }) =>
    $isInverted &&
    css`
      background-color: ${({ theme }) => theme.color.gray[0]};
      color: ${({ theme }) => theme.text.color.default};
    `}
`;

export const BetaAILabelWrapper = styled.span`
  padding: 1px 0 0;
  white-space: nowrap;
  display: flex;
  align-items: center;

  > i {
    font-size: 6px;
    padding: 0 2px;
    margin-inline: 0;
  }
`;
